import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'hcon-table-row',
  template: '<ng-content></ng-content>',
  styleUrls: ['./table-row.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TableRowComponent {}
